import HttpError from './HttpError';

export default class InvitationAcceptedError extends HttpError {}
